import {createContext} from "react";
import {useModals} from "./useModals";
import { InnocodeProviderWrapper } from "@intsoft/innocode-core";

export const ModalContext = createContext();

const ModalProvider = ({children}) => {
    const modals = useModals();

    return (
        <InnocodeProviderWrapper>
            <ModalContext.Provider value={modals}>
                {children}
            </ModalContext.Provider>
        </InnocodeProviderWrapper>
    )
}

export default ModalProvider;